import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation, faCircleInfo, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { PopupConfirmService } from '../../services/popup-confirm.service';

@Component({
  selector: 'app-popup-confirm',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './popup-confirm.html',
  styleUrls: ['./popup-confirm.scss'],
})
export class PopupConfirm {
  private readonly popupConfirmService = inject(PopupConfirmService);

  readonly confirm$ = this.popupConfirmService?.confirm$;

  // Font Awesome icons
  faTriangleExclamation = faTriangleExclamation;
  faCircleInfo = faCircleInfo;
  faXmark = faXmark;

  cancel(): void {
    this.popupConfirmService.dismiss();
  }

  confirm(): void {
    this.popupConfirmService.confirm();
  }

  getIcon(type?: 'danger' | 'warning' | 'info') {
    switch (type) {
      case 'danger':
        return this.faTriangleExclamation;
      case 'warning':
        return this.faTriangleExclamation;
      case 'info':
        return this.faCircleInfo;
      default:
        return this.faCircleInfo;
    }
  }
}
